import "./Petitions.module.css";
import Header from "@/reusable_sections/Header";
import DilekElerintro from "./sections/DilekElerintro";
import Petitioncategories from "./sections/Petitioncategories";
import Legaldisclaimer from "./sections/Legaldisclaimer";
import DilekElericta from "./sections/DilekElericta";
import Footer from "@/reusable_sections/Footer";
export default function PetitionsPage() {
  return <div>
      <Header />
      <DilekElerintro />
      <Petitioncategories />
      <Legaldisclaimer />
      <DilekElericta />
      <Footer />
    </div>;
}